import { FC, ReactNode } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SpacingProps } from '@mui/system'

export type LabelProps = {
    htmlFor: string
    error?: boolean
    children?: ReactNode
} & SpacingProps

const defaultSpacingProps: SpacingProps = {
    mb: 1,
}

const Label: FC<LabelProps> = ({ children, htmlFor, error, ...spacingProps }) => (
    <Box {...defaultSpacingProps} {...spacingProps}>
        <Typography color={error ? 'error' : 'initial'} component="label" variant="subtitle1" htmlFor={htmlFor}>
            {children}
        </Typography>
    </Box>
)

export default Label
